import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import VisionBanner from "../../Assets/vision.webp";
import { Link } from "react-router-dom";

const VisionMission = () => {
  return (
    <div>
      <Header />

      {/* Banner Section */}
      <section
        className="container-fluid common_banner"
        style={{
          backgroundImage: `url(${VisionBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="common_title wow fadeInUp">
                <h2>
                  <Link
                    to="/AboutUs"
                    className="text-decoration-none text-white"
                  >
                    ABOUT US
                  </Link>{" "}
                  <span className="text-white">/ Vision & Mission</span>
                </h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="container-fluid about_Products_section py-5">
        <div className="container">
          <div className="row">

            {/* Vision */}
            <div className="col-lg-12 mb-5 wow fadeInUp">
              <h2
                style={{
                  color: "#153fa4",
                  fontSize: "40px",
                  fontWeight: "700",
                  marginBottom: "20px",
                }}
              >
                Our Vision
              </h2>

              <p>
                At Khodiyar Industries, our vision is to establish ourselves as
                one of the most trusted and respected names in the automotive
                glass industry. We aim to build a brand that symbolizes quality,
                reliability, innovation, and customer confidence.
              </p>

              <p>
                Through continuous technological advancement, superior product
                quality, and customer-centric solutions, we strive to become an
                industry leader while contributing to the growth and development
                of the automotive sector. Our commitment is to exceed customer
                expectations and create long-term value for our customers,
                employees, and stakeholders.
              </p>

              <p>
                We envision sustainable growth through innovation, operational
                excellence, and continuous improvement, ensuring a stronger and
                brighter future for generations to come.
              </p>
            </div>

            {/* Mission */}
            <div className="col-lg-12 wow fadeInUp">
              <h2
                style={{
                  color: "#153fa4",
                  fontSize: "40px",
                  fontWeight: "700",
                  marginBottom: "20px",
                }}
              >
                Our Mission
              </h2>

              <ul
                style={{
                  lineHeight: "2",
                  fontSize: "17px",
                  paddingLeft: "20px",
                }}
              >
                <li>
                  To provide advanced technology and innovative automotive glass
                  solutions to our customers.
                </li>

                <li>
                  To manufacture premium-quality toughened and tempered glass
                  products that meet industry standards.
                </li>

                <li>
                  To deliver consistent, reliable, and customer-focused service.
                </li>

                <li>
                  To establish Khodiyar India as a recognized and trusted brand
                  across national and international markets.
                </li>

                <li>
                  To maintain the highest standards of quality, safety, and
                  performance in every product we manufacture.
                </li>

                <li>
                  To continuously innovate and improve our products and
                  manufacturing processes.
                </li>

                <li>
                  To build lasting relationships with customers through trust,
                  transparency, and excellence.
                </li>

                <li>
                  To contribute positively to society through ethical business
                  practices and sustainable growth.
                </li>
              </ul>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VisionMission;
